module.exports = __webpack_public_path__ + "static/media/logout.7495740b.png";